import React from "react";
import "./ContactUs.css";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaClock, FaPaperPlane } from "react-icons/fa";

const ContactUs = () => {
  return (
    <div className="contactUs-container">
      {/* Hero */}
      <section className="contactUs-hero">
        <h1>Contact Us</h1>
        <p>
          Need a cab, tempo traveller, or bus rental in Hyderabad? 
          We’re available 24/7 to assist you with bookings and queries.
        </p>
      </section>

      {/* Contact Content */}
      <div className="contactUs-wrapper">
        {/* Left Side: Info */}
        <div className="contactUs-info">
          <h2>Get in Touch</h2>
          <p className="contactUs-info-subtext">
            Reach out to us anytime — we’ll respond as quickly as possible.
          </p>
          <div className="contactUs-info-item">
            <FaPhoneAlt className="contactUs-info-icon" />
            <div>
              <h4>Phone</h4>
              <p>+91 9701238500</p>
            </div>
          </div>
          <div className="contactUs-info-item">
            <FaEnvelope className="contactUs-info-icon" />
            <div>
              <h4>Email</h4>
              <p>booking@hyderabadtoursandtravels.com</p>
            </div>
          </div>
          <div className="contactUs-info-item">
            <FaMapMarkerAlt className="contactUs-info-icon" />
            <div>
              <h4>Address</h4>
              <p># 5 - 9 - 101/D, Assembly Metro Station, Opp. Public Gardens, Nampally, Hyderabad - 500001</p>
            </div>
          </div>
          <div className="contactUs-info-item">
            <FaClock className="contactUs-info-icon" />
            <div>
              <h4>Working Hours</h4>
              <p>Available 24/7</p>
            </div>
          </div>
        </div>

        {/* Right Side: Form */}
        <div className="contactUs-form">
          <h2>Send Us a Message</h2>
          <form>
            <input type="text" placeholder="Your Name" required />
            <input type="email" placeholder="Your Email" required />
            <input type="tel" placeholder="Your Phone" required />
            <textarea placeholder="Your Message" rows="5" required></textarea>
            <button type="submit" className="contactUs-submit-btn">
              Send Message <FaPaperPlane className="contactUs-btn-icon" />
            </button>
          </form>
        </div>
      </div>

      {/* Map */}
      <div className="contactUs-map">
      <iframe
        title="Hyderabad Location"
        src="https://www.google.com/maps?q=Assembly+Metro+Station+Nampally+Hyderabad&output=embed"
        width="100%"
        height="350"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
      ></iframe>
      </div>
    </div>
  );
};

export default ContactUs;
